export const RESET_DEPARTMENTS = "RESET_DEPARTMENTS";
export const RESET_DEPARTMENT = "RESET_DEPARTMENT";
export const RESET_ERROR = "RESET_ERROR";

export const GET_DEPARTMENTS = "GET_DEPARTMENTS";
export const SET_DEPARTMENTS = "SET_DEPARTMENTS";

export const API_ERROR = "DEPARTMENTS_API_ERROR";

export const GET_DEPARTMENT = "GET_DEPARTMENT";
export const SET_DEPARTMENT = "SET_DEPARTMENT";

export const EDIT_DEPARTMENT = "EDIT_DEPARTMENT";
export const EDIT_DEPARTMENT_SUCCESS = "EDIT_DEPARTMENT_SUCCESS";

export const CREATE_DEPARTMENT = "CREATE_DEPARTMENT";
export const CREATE_DEPARTMENT_SUCCESS = "CREATE_DEPARTMENT_SUCCESS";

export const DELETE_DEPARTMENT = "DELETE_DEPARTMENT";
export const DELETE_DEPARTMENT_SUCCESS = "DELETE_DEPARTMENT_SUCCESS";
